import axios from 'axios';
import './focus-visible.js'; // focus on tab
import 'magnific-popup'; // NPM Import for modals
import 'lazysizes/plugins/respimg/ls.respimg'; // responsive image polyfill
import 'lazysizes/plugins/bgset/ls.bgset.js'; // NPM Import, lazy loading bgset
import 'lazysizes/plugins/respimg/ls.respimg.js'; // NPM Import, lazy loading responsive images
import 'lazysizes'; // NPM Import, image lazy loading
import './menu.js';
import './plugins/accordion.plugin';
import './vimeo-tracker.js';

$(function () {
    // global var for large screen media query
    let mq = window.matchMedia("(min-width: 1024px)");
    // global var for medium screen media query
    let mqMed = window.matchMedia("(min-width: 576px)");
    let cntrlIsPressed = false;

    // accordions
    let $accordion = $('.accordion');
    $accordion.accordion({
        singleOpen: true,
        hiddenOnLoad: true
    });
    $('.hero__accordion').find('.accordion__wrapper:first-child').removeClass(['-close', '-initiallyHidden']).addClass('-open');

    /* Smooth Scrolling for Jump Links */
    $('a').not('.modal').not('.vue-btn').not('[href^="#tab"]').click(function () {
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
            let target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            if (target.length) {
                $('html,body').animate({
                    scrollTop: target.offset().top - 120
                }, 1000);
                return false;
            }
        }
    });

    $(document).keydown(function(event){
        if(event.which=="91" || event.which=="224")
            cntrlIsPressed = true;
    });

    $(document).keyup(function(){
        cntrlIsPressed = false;
    });

    /* member activity tracking on anchor tag links */
    $('a.trackPageView').click(function (e) {
        let clonedEvent = e;
        e.preventDefault();
        let url = this.href;
        let promise = trackClick('page', $(this).data('elementid'));

        var a = new RegExp('/' + window.location.host + '/');
        if (a.test(this.href)) {

            promise.then(response => {
                // console.log(url); // for debugging
                if (cntrlIsPressed) {
                    window.open(this.href, '_blank');
                } else {
                    window.location.href = url;
                }
            })
                .catch(error => {
                    console.log(error.response); // for debugging
                });
        }
    });

    $('a.trackDownload').click(function (e) {
        e.preventDefault();
        let url = this.href;
        let promise = trackClick('download', $(this).data('elementid'), $(this).data('entryid'));

        promise.then(response => {
            // console.log(url); // for debugging
            //window.location.href = url; // client wants links to open in new window which the offsite links method will do
        })
            .catch(error => {
                console.log(error.response); // for debugging
            });
    });

    /** 'Back to Top' widget **/
    // only show back to top button after certain scroll
    $('.button.-backToTop').hide;
    $(window).scroll(function () {
        if ($(window).scrollTop() > 900) {
            $('.button.-backToTop').css({ 'opacity': 1 });
        } else {
            $('.button.-backToTop').css({ 'opacity': 0 });
        }
    });
    $(window).scroll();

    /** Modals functionality **/
    $('.modal').magnificPopup({
        type: 'inline',
        closeBtnInside: true,
        // closeOnContentClick: true,
        closeMarkup: '<button class="mfp-close"><img src="/media/images/icons/cancel.svg" alt="Close Pop-up"/></button>',
        fixedContentPos: 'true',
        overflowY: 'scroll',
        fixedBgPos: true
    });

    $(document).ready(function() {

        if(window.location.href.indexOf('#contact-modal') != -1) {
          $.magnificPopup.open({items: {src: '#contact-modal'},type: 'inline'}, 0);
        }

    });

    /* Open Offsite Links in New Tab */
    $('a').each(function () {
        var site = new RegExp('/' + window.location.host + '/');
        var communitysite = new RegExp('/community.cutterassociates.com/');
        var download = new RegExp('download\?');
        var pdf = new RegExp('.pdf');
        if ((!site.test(this.href) && !communitysite.test(this.href)) || (download.test(this.href) || pdf.test(this.href))) {
            $(this).on('click', (function (event) {
                event.preventDefault();
                event.stopPropagation();
                window.open(this.href, '_blank');
            }));
        }
    });

});

/** Track member activity on click **/
function trackClick(type, elementId, entryId) {
    let url = '';

    switch (type) {
        case 'download':
            url = '/actions/reporting/log/download';
            break;
        case 'page':
            url = '/actions/reporting/log';
            break;
        default:
            url = '/actions/reporting/log';
    }

    let data = {
        id: elementId,
        entryId: entryId,
        CRAFT_CSRF_TOKEN: csrfTokenValue
    };

    return axios.post(url, data);
}
